<template>
  <div class="basePage">
    <BaseSearch v-bind="searchConfig" @action="doAction" @input="onInput"></BaseSearch>
    <BaseTable v-bind="tableConfig" @operation="doOperation" @selection="onSelection"
               @sortChange="onSortChange"></BaseTable>
    <div class="footer">
      <BasePagination v-bind="paginationConfig" @action="doAction" :curPage.sync="curPage"
                      :pageSize.sync="pageSize"></BasePagination>
    </div>
  </div>
</template>

<script>

import BaseSearch from './BaseSearch'
import BaseTable from './BaseTable'
import BasePagination from './BasePagination'

export default {
  name: "BasePage",
  components: {
    BaseSearch, BaseTable, BasePagination
  },
  props: {
    searchConfigs: Array,
    actions: Array,
    tableConfigs: Array,
    list: Array,
    activeIndex: String,
    endPagination: Boolean,
    count: Number,
    showCreate: {
      type: Boolean,
      required: false,
      default: true
    },
    showExport: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function () {
    return {
      curPage: 1,
      pageSize: 20,
      curList: []
    }
  },
  watch: {
    activeIndex: function () {
      this.curPage = 1
    },
    'list.length': function () {
      this.curPage = 1
    }
  },
  mounted: function () {
    this.init();
  },
  computed: {
    searchConfig: function () {
      return {
        configs: this.searchConfigs,
        actions: this.actions,
        showCreate: this.showCreate,
        showExport: this.showExport
      }
    },
    tableConfig: function () {
      this.initCurList();
      return {
        configs: this.tableConfigs,
        list: this.curList,
        expand: this.expand
      }
    },
    paginationConfig: function () {
      return {
        endPagination: this.endPagination,
        total: this.endPagination ? this.count : this.list.length,
      }

    },
    /*   curList: function () {
           console.log("curList change")
           let start = (this.curPage-1)*this.pageSize
           let end = _.min([this.list.length,start+this.pageSize])
           return  this.endPagination? this.list : _.slice(this.list, start, end)

       },*/
  },
  methods: {
    init: function () {

    },
    doAction: function (action) {
      this.$emit('action', action);
    },
    doOperation: function (op) {
      this.$emit('operation', op);
    },
    onInput: function (val) {
      this.$emit('input', val);
    },
    onSelection: function (val) {
      this.$emit('selection', val);
    },
    onSortChange: function (column) { // column是个形参，具体查看element-ui文档
      this.curPage = 1 // return to the first page after sorting
      this.total = this.list.length
      let list = this.list.sort(this.sortFun(column.prop, column.order === 'ascending'));
      this.curList = list.slice(0, this.pageSize) // 排序完显示到第一页
    },
    sortFun: function (attr, rev) {
      //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = (rev) ? 1 : -1;
      }
      if (attr === "createTime") {
        return function (a, b) {
          a = a[attr];
          b = b[attr];
          if (new Date(a) < new Date(b)) {
            return rev * -1;
          }
          if (new Date(a) > new Date(b)) {
            return rev * 1;
          }
          return 0;
        }
      } else {
        return function (a, b) {
          a = a[attr];
          b = b[attr];
          if (a < b) {
            return rev * -1;
          }
          if (a > b) {
            return rev * 1;
          }
          return 0;
        }
      }
    },
    handleCurrentChange(val) {
      this.curPage = val
      this.curList = this.list.slice((this.curPage - 1) * this.pageSize, this.curPage * this.pageSize)
    },
    initCurList: function () {
      let start = (this.curPage - 1) * this.pageSize
      let end = _.min([this.list.length, start + this.pageSize])
      this.curList = this.endPagination ? this.list : _.slice(this.list, start, end)
    }

  }

}
</script>

<style scoped>
.footer {
  border: solid 1px #e9e9e9;
  border-top-style: hidden;
  min-height: 20px;
  padding: 15px;
}

</style>
